<template>
  <label for="isBrandMEQ">{{
    t('sites.singleSite.financialConfig.mealPlans.form.mealEquivalency')
  }}</label>
  <SelectButtonField
    id="isBrandMEQ"
    :name="`${formNamespace}isBrandMEQ`"
    :options="brandMEQOptions"
    optionLabel="label"
    optionValue="value"
    :unselectable="false"
    :disabled="isBrandMX || isBrandMXFieldValue || !hasMEQTenders || !editMealPlan"
  />
</template>

<script setup lang="ts">
import { useI18n } from 'vue-i18n';
import { storeToRefs } from 'pinia';
import { inject } from 'vue';
import { useFieldValue } from 'vee-validate';
import { useFinancialConfigStore } from '../../../../../../routes/stores/use-financial-config-store';
import useTenderType from '../../composables/use-tender-type/use-tender-type';

const { t } = useI18n();

const { brandMEQOptions, isBrandMX, hasMEQTenders } = useTenderType();

const fConfigStore = useFinancialConfigStore();
const { editMealPlan } = storeToRefs(fConfigStore);

const formNamespace = inject('formNamespace', '');
const isBrandMXFieldValue = useFieldValue<string>(`${formNamespace}isBrandMX`);
</script>
